var _rect, _path, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRandomImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 300,
    viewBox: "0 0 620 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 300,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 57C47 51.4772 51.4772 47 57 47H617V291C617 294.314 614.314 297 611 297H47V57Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 20,
    fill: "#828282"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 547,
    y: 83,
    width: 50,
    height: 8,
    rx: 4,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 83,
    width: 50,
    height: 8,
    rx: 4,
    fill: "#BDBDBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 427,
    y: 83,
    width: 50,
    height: 8,
    rx: 4,
    fill: "#828282"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 127,
    width: 527,
    height: 140,
    rx: 3,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 172,
    width: 300,
    height: 20,
    fill: "#BDBDBD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 202,
    width: 250,
    height: 20,
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomImg);
export default __webpack_public_path__ + "static/media/randomImg.36f7aaf16db3aff5677caf2153ef396c.svg";
export { ForwardRef as ReactComponent };